import { Tag, TagLabel } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import {
  utils as commonUtils,
  finleyAssertUnreachable,
} from '@finley-technologies/common';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { TagIcon } from '~/packages/common-frontend/components/icons';
import { ColorScheme } from '~/packages/common-frontend/theme';

// Exports
export const EnvironmentTag = () => {
  const { user } = useUserAuthOrThrow();

  const tagProps = useMemo<{
    colorScheme: ColorScheme;
    label: string;
  } | null>(() => {
    const env = commonUtils.EnvUtils.getEnv();
    switch (env) {
      case 'development': {
        return { colorScheme: 'blue', label: 'Development' };
      }
      case 'stage': {
        return { colorScheme: 'blue', label: 'Staging' };
      }
      case 'prod': {
        if (!user.email.endsWith('finleycms.com')) return null;
        return { colorScheme: 'red', label: 'Production' };
      }
      case 'client-uat': {
        return { colorScheme: 'orange', label: 'Client UAT' };
      }
      case 'client': {
        return { colorScheme: 'orange', label: 'Client' };
      }
      default: {
        throw finleyAssertUnreachable(env);
      }
    }
  }, [user.email]);

  if (!tagProps) return null;
  return (
    <Tag size="sm" variant="solid-muted" colorScheme={tagProps.colorScheme}>
      <TagIcon icon="keyboard" />
      <TagLabel>{tagProps.label}</TagLabel>
    </Tag>
  );
};
